import { uuidGenerator } from '../../../helper'
import { logger } from '../../../logger/logger'
import { getClientMonitorBaseUrl, isClientMonitorBrowserTest, isNativeAppMode } from '../../../helper/clientMonitor'

export const secondWindowStore = {}

const CUSTOMER_DISPLAY_PATH = '/pos/customer-display'
const WINDOW_PARAMS = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no'
const APP_MODE_QUERY = '?appMode=LIEFERSOFT_POS_APP'

const postToNativeApp = (type, data) => {
	window.ReactNativeWebView?.postMessage(
		JSON.stringify({ eventId: uuidGenerator(), traceId: uuidGenerator(), type, context: 'kassa-web', eventTime: new Date().toISOString(), data })
	)
}

const isNativeBridge = () => isNativeAppMode() && window.ReactNativeWebView

export const openClientMonitorWindow = () => {
	logger.info('Opening client monitor window ...')
	if (isNativeBridge()) {
		postToNativeApp('kassa-web.CLIENT_MONITOR_ACTIVATED', { url: getClientMonitorBaseUrl() + CUSTOMER_DISPLAY_PATH + APP_MODE_QUERY })
		return null
	}
	if (!isClientMonitorBrowserTest()) {
		return null
	}
	const url = getClientMonitorBaseUrl() + CUSTOMER_DISPLAY_PATH + APP_MODE_QUERY
	if (!secondWindowStore.window || secondWindowStore.window.closed) {
		secondWindowStore.window = window.open(url, 'client-monitor', WINDOW_PARAMS)
	}
	return secondWindowStore.window
}

export const closeClientMonitorWindow = () => {
	logger.info('Closing client monitor window ...')
	if (isNativeBridge()) {
		postToNativeApp('kassa-web.CLIENT_MONITOR_DEACTIVATED', {})
		return
	}
	secondWindowStore.window?.close?.()
}

export const sendMessageToClientMonitor = (eventType, data) => {
	if (isNativeBridge()) {
		postToNativeApp('kassa-web.CLIENT_MONITOR_EVENT', { type: eventType, data })
		return
	}
	secondWindowStore.window?.postMessage({ eventId: uuidGenerator(), traceId: uuidGenerator(), type: eventType, data }, '*')
}

export const sendMessageToParentWindow = (eventType, data) => {
	if (isNativeBridge()) {
		if (eventType === 'client-monitor.CLIENT_MONITOR_LOADED') {
			window.ClientMonitorNative?.notifyReady()
		}
		return
	}
	window.opener?.postMessage({ eventId: uuidGenerator(), traceId: uuidGenerator(), type: eventType, data }, '*')
}
